import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

export interface IHttpRequest {
  route: string,
  body?: any
}

export abstract class ApiService {
  protected _baseApiPath = environment.apiBase;
  protected _defaultHttpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(protected _http: HttpClient, baseApiPath: string) {
    this._baseApiPath = baseApiPath;
    if (!this._baseApiPath.endsWith('/')) {
      this._baseApiPath += '/';
    }
  }

  protected _get<T>(request: IHttpRequest): Observable<T> {
    const queryString = new URLSearchParams(request.body).toString();
    return this._http.get<T>(`${this._baseApiPath}${request.route}?${queryString}`, this._defaultHttpOptions);
  }

  protected _download(request: IHttpRequest & { httpMethod?: 'POST'|'GET'}) : Observable<HttpResponse<Blob>> {
    const httpOptions = {
        headers: new HttpHeaders(),
        observe: 'response' as 'body',
        responseType: 'blob' as 'json'
    }

    if ((request.httpMethod ?? 'GET') === 'GET') {
      const queryString = new URLSearchParams(request.body).toString();
      return this._http.get<HttpResponse<Blob>>(`${this._baseApiPath}${request.route}?${queryString}`, httpOptions);
    } else {
      return this._http.post<HttpResponse<Blob>>(`${this._baseApiPath}${request.route}`, request.body, httpOptions);
    }
  }

  protected _put<T>(request: IHttpRequest): Observable<T> {
    return this._http.put<T>(`${this._baseApiPath}${request.route}`, request.body, this._defaultHttpOptions);
  }

  protected _post<T>(request: IHttpRequest): Observable<T> {
    return this._http.post<T>(`${this._baseApiPath}${request.route}`, request.body, this._defaultHttpOptions);
  }

  protected _postFiles<T>(request: IHttpRequest): Observable<T> {
    const headers = { enctype: 'multipart/form-data' };
    return this._http.post<T>(`${this._baseApiPath}${request.route}`, request.body, { headers });
  }

  protected _delete<T>(request: IHttpRequest): Observable<T> {
    const queryString = new URLSearchParams(request.body).toString();
    return this._http.delete<T>(`${this._baseApiPath}${request.route}?${queryString}`, this._defaultHttpOptions);
  }
}
